"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openRootNavItem = openRootNavItem;
exports.openSubNavItem = openSubNavItem;
exports.closeSubNavItem = closeSubNavItem;
exports.closeMenu = closeMenu;
exports.toggleProfileResetConfirmationOn = toggleProfileResetConfirmationOn;
exports.toggleProfileResetConfirmationOff = toggleProfileResetConfirmationOff;
function openRootNavItem(navItem) {
    return {
        type: "main-menu/OPEN_ROOT_NAV_ITEM",
        payload: navItem
    };
}
function openSubNavItem(navItem) {
    return {
        type: "main-menu/OPEN_SUB_NAV_ITEM",
        payload: navItem
    };
}
function closeSubNavItem() {
    return {
        type: "main-menu/CLOSE_SUB_NAV_ITEM"
    };
}
function closeMenu() {
    return {
        type: "main-menu/CLOSE_MENU"
    };
}
function toggleProfileResetConfirmationOn() {
    return {
        type: "main-menu/TOGGLE_PROFILE_RESET_CONFIRMATION_ON"
    };
}
function toggleProfileResetConfirmationOff() {
    return {
        type: "main-menu/TOGGLE_PROFILE_RESET_CONFIRMATION_OFF"
    };
}
//# sourceMappingURL=actions.js.map